import _extends from "@babel/runtime-corejs3/helpers/extends";

var _context;

import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _Object$assign from "@babel/runtime-corejs3/core-js-stable/object/assign";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import * as _ from "../../../util/lodash";
import React from 'react';
import { createComponent, PropTypes, Utils } from "../../../wayin-react";
import classnames from 'classnames';
import { widths, colors, textAlignments, positions, directions } from "../../../enums";
import { toUIProps } from "../../../util";
import { removeProps, whitelistStyles } from "../hoc";
import { compose } from 'react-recompose';
import { GridRow as UIGridRow } from 'semantic-ui-react';
import LayoutColumn, { PrivateLayoutColumn } from "./layout-column";
var UNSUPPORTED_PROPS = ['as', 'centered', 'divided', 'className', 'reversed', 'stretched', 'only'];
var ADDED_PROPS = ['borders', 'isCentered', 'isInverted', 'columnStyles', '_parentColumnStyles', '_parentRowStyles'];
var MODIFIED_PROPS = ['color'];
var propMap = {};
var LayoutRow = createComponent({
  displayName: 'LayoutRow',
  propTypes: {
    children: PropTypes.node,
    borders: PropTypes.oneOf([directions.H]),
    isCentered: PropTypes.bool,
    columns: PropTypes.oneOf(_concatInstanceProperty(_context = []).call(_context, widths.ALL, ['equal'])),
    columnStyles: PropTypes.shape({
      backgroundColor: PropTypes.oneOf(colors.CORE),
      "float": PropTypes.oneOf(positions.LR),
      textAlign: PropTypes.oneOf(textAlignments.ALL),
      verticalAlign: PropTypes.oneOf(positions.alignColumns.ALL),
      isContentCentered: PropTypes.bool
    }),
    _parentColumnStyles: PropTypes.shape({
      backgroundColor: PropTypes.oneOf(colors.CORE),
      "float": PropTypes.oneOf(positions.LR),
      textAlign: PropTypes.oneOf(textAlignments.ALL),
      verticalAlign: PropTypes.oneOf(positions.alignColumns.ALL),
      isContentCentered: PropTypes.bool
    }),
    _parentRowStyles: PropTypes.shape({
      isCentered: PropTypes.bool
    })
  },
  defaultProps: {
    children: undefined,
    columns: null,
    borders: null,
    isCentered: undefined,
    columnStyles: {},
    _parentColumnStyles: {},
    _parentRowStyles: {}
  },
  contextTypes: {
    isInverted: PropTypes.bool
  },
  render: function render(props) {
    var UIProps = toUIProps({
      props: props,
      propMap: propMap,
      ADDED_PROPS: ADDED_PROPS,
      UNSUPPORTED_PROPS: UNSUPPORTED_PROPS,
      MODIFIED_PROPS: MODIFIED_PROPS
    });
    delete UIProps.children;
    UIProps = _Object$assign(UIProps, getRowStyles(props._parentRowStyles, props));

    var _parentColumnStyles = getColumnStyles(props._parentColumnStyles, props.columnStyles);

    var propChildren = React.Children.toArray(props.children);
    var colProps;

    var children = _mapInstanceProperty(_).call(_, propChildren, function (child, index) {
      if (Utils.isType([LayoutColumn, PrivateLayoutColumn], child)) {
        colProps = _Object$assign({}, child.props, {
          _parentColumnStyles: _parentColumnStyles,
          key: index
        });
        return /*#__PURE__*/React.createElement(PrivateLayoutColumn, colProps);
      } else {
        var _colProps = {
          _parentColumnStyles: _parentColumnStyles,
          key: index
        };
        return /*#__PURE__*/React.createElement(PrivateLayoutColumn, _colProps, child);
      }
    });

    var classNames = classnames(_parentColumnStyles.backgroundColor, {
      inverted: props.isInverted,
      'horizontally divided': props.borders === directions.H
    });
    return /*#__PURE__*/React.createElement(UIGridRow, _extends({}, UIProps, {
      className: classNames
    }), children);
  }
});
var defaultRowStyles = {
  isCentered: false
};

function getRowStyles(parent, overrides) {
  var rowStyles = _Object$assign({}, defaultRowStyles, parent);

  return {
    centered: getDefaultOrOverrideVal(rowStyles.isCentered, overrides.isCentered)
  };
}

function getColumnStyles(parent, overrides) {
  return _Object$assign({}, parent, overrides);
}

function getDefaultOrOverrideVal(defaultVal, overrideVal) {
  return overrideVal === undefined ? defaultVal : overrideVal;
}

export var PrivateLayoutRow = whitelistStyles()(LayoutRow);
export default removeProps(['_parentColumnStyles', '_parentRowStyles'])(PrivateLayoutRow);
//# sourceMappingURL=layout-row.js.map